// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
// import CommentBox from './CommentBox';

//
ReactDOM.render(
  <App />,
  document.getElementById('root'));
// ReactDOM.render(<CommentBox />, document.getElementById('root'));

// ReactDOM.render(<Login />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js